<mat-form-field
    [ngClass]="errorStateMatcher?.validationClass ?? 'valid'"
    [appearance]="appearance ?? 'fill'"
>
    <span
        *ngIf="icon"
        matPrefix
        ><i class="{{ icon }}"></i
    ></span>
    <mat-label appRemoveAriaOwns>{{ property.displayKey ? 'Select ' + property.Key : '' }}</mat-label>
    <mat-date-range-input
        [rangePicker]="datePicker"
        [dateFilter]="property.dateFilter"
    >
        <input
            matStartDate
            [value]="startDate"
            (dateChange)="startDateChanged($event); errorStateMatcher?.markAsInteracted()"
            (blur)="errorStateMatcher?.markAsInteracted()"
            (click)="datePicker.open()"
            [errorStateMatcher]="errorStateMatcher"
        />
        <input
            matEndDate
            [value]="endDate"
            (dateChange)="endDateChanged($event); errorStateMatcher?.markAsInteracted()"
            (blur)="errorStateMatcher?.markAsInteracted()"
            (click)="datePicker.open()"
            [errorStateMatcher]="errorStateMatcher"
        />
    </mat-date-range-input>
    <mat-datepicker-toggle
        matSuffix
        [for]="datePicker"
    ></mat-datepicker-toggle>
    <mat-date-range-picker
        #datePicker
        [disabled]="disabled ? disabled : null"
        (closed)="closed()"
    >
    </mat-date-range-picker>
    <mat-hint>{{ property.hint }}</mat-hint>
    <mat-error *ngIf="property.validationError">{{ property.validationError }}</mat-error>
</mat-form-field>
